import { keepPreviousData, queryOptions, useMutation, useQuery } from '@tanstack/react-query';
import { generateFiuUtr, searchFiuUtrClient } from '@/services/api/fiu-utr';

export const FIU_UTR_QUERY_KEY = ['compliance', 'fiu-utr'] as const;

export const fiuUtrSearchQueryOptions = (pid: string) =>
  queryOptions({
    queryKey: [...FIU_UTR_QUERY_KEY, 'search', pid],
    queryFn: () => searchFiuUtrClient(pid),
    enabled: pid.length > 0,
    // Legacy keeps the previous client's results on screen while a new PID search is in flight
    placeholderData: keepPreviousData,
    // A filing is assembled from point-in-time data: searching a PID again must always
    // refetch (it also drives the override-reset effect via dataUpdatedAt),
    // never serve the 5-minute default cache.
    staleTime: 0,
  });

export const useFiuUtrSearch = (pid: string) => useQuery(fiuUtrSearchQueryOptions(pid));

export const useGenerateFiuUtr = () => useMutation({ mutationFn: generateFiuUtr });
